import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Storage } from '@ionic/storage';
import { environment } from '../../environments/environment';
import { FileChooser } from '@ionic-native/file-chooser';
import { FilePath } from '@ionic-native/file-path';
import { Base64 } from '@ionic-native/base64';
import { File as NativeFile } from '@ionic-native/file';
import { ToastProvider } from '../../providers/toast/toast';
import { ImagePicker, ImagePickerOptions, OutputType } from '@ionic-native/image-picker';
import { Camera, CameraOptions } from '@ionic-native/camera';
@Injectable()
export class ExtraProvider {
  ismURL = environment.ismUrl;
  private panicData: PanicData = {};

  options: ImagePickerOptions = {
    maximumImagesCount: 1,
    quality: 50,
      // width: int,
      // height: int,
    outputType: OutputType.DATA_URL
  }

  cameraOptions: CameraOptions = {
    quality: 50,
    destinationType: this.camera.DestinationType.DATA_URL,
    encodingType: this.camera.EncodingType.JPEG,
    mediaType: this.camera.MediaType.PICTURE,
    // correctOrientation: true,
    // saveToPhotoAlbum: false,
  }
  constructor(public http: HttpClient, 
    private storage :Storage,
    private fileChooser: FileChooser,
    private filePath: FilePath,
    private base64: Base64,
    private file: NativeFile,
    private toast: ToastProvider,
    private imagePicker: ImagePicker,
    private camera: Camera) {}

  getPanicContacts(){
  	return this.getToken().then((val) => {
      if(val){
        return this.http.post<Response>(this.getUrl(this.ismURL, `/paniccontacts`,val),{})
        .toPromise();
      }
    });
  }

  sendPanicMessage(type: string, message: string){
    this.panicData.type = type;
    if(message && message.length > 0){
      this.panicData.message = message;
    }
  	return this.getToken().then((val) => {
      if(val){
        return this.http.post<Response>(this.getUrl(this.ismURL, `/panic`,val), this.panicData)
        .toPromise();
      }
    });
  }

  getSocietyDetails(){
  	return this.getToken().then((val) => {
      if(val){
        return this.http.get<any>(this.getUrl(this.ismURL, `/society/${val.societyId}`,val))
        .toPromise();
      }
    });
  }

  getNotifications(){
    return this.getToken().then((val) => {
      if(val){
        return this.http.get<Response>(this.getUrl(this.ismURL, `/getmynotifications`,val))
        .toPromise();
      }
    });
  }

  addFamilyMember(data){
    return this.getToken().then((val) => {
      if(val){
        return this.http.post<Response>(this.getUrl(this.ismURL, `/addFamilyMember`,val), data)
        .toPromise();
      }
    });
  }

  editFamilyMember(data){
    return this.getToken().then((val) => {
      if(val){
        return this.http.put<Response>(this.getUrl(this.ismURL, `/updatefamilymember`,val), data)
        .toPromise();
      }
    });
  }

  getMembers(){
    return this.getToken().then((val) => {
      if(val){
        return this.http.get<Response>(this.getUrl(this.ismURL, `/${val.societyId}/${val.id}/members`,val))
        .toPromise();
      }
    });
  }
  
  deleteMember(member){
    return this.getToken().then((val) => {
      if(val){
        return this.http.delete<Response>(this.getUrl(this.ismURL, `/deleteFamilyMember/${member.id}`,val))
        .toPromise();
      }
    });
  }

  chooseFile(){
    return this.fileChooser.open().then(uri => {
      return {
        uri
      }
    }).then(val => {
      return this.file.resolveLocalFilesystemUrl(val.uri).then(fileEntry => {
        return {
          uri: val.uri,
          fileEntry
        }
      });
    }).then(val => {
      return this.filePath.resolveNativePath(val.uri).then(file => {
        return {
          uri: val.uri,
          fileEntry: val.fileEntry,
          file
        }
      });
    }).then(val => {
      return this.base64.encodeFile(val.file).then((base64File: string) => {
        return {
          uri: val.uri,
          fileEntry: val.fileEntry,
          file: val.file,
          base64File
        }
      });
    });
  }

  imgPicker(options?){
    return this.imagePicker.getPictures(options ? options : this.options).then((results) => {
      return results
    })
  }
  clickPicture(options?){
    return this.camera.getPicture(options ? options : this.cameraOptions).then((val) => {
      return val
    }, (err) => {
        console.log('error')
    });
  }
//   dataURLtoFile(dataurl, filename) {
//     var arr = dataurl.split(','),
//         mime = arr[0].match(/:(.*?);/)[1],
//         bstr = atob(arr[1]), 
//         n = bstr.length, 
//         u8arr = new Uint8Array(n);   
//     while(n--){
//         u8arr[n] = bstr.charCodeAt(n);
//     }
//     return new File([u8arr], filename, {type:mime});
// }

  convertUriToBase64IOS(uri: string){
    return this.base64.encodeFile(uri).then((base64File: string) => {
      return {
        base64File
      }
    });
  }

  convertUriToBase64(uri: string){
    return this.filePath.resolveNativePath(uri).then(file => {
      return {
        file
      }
    }).then(val => {
      return this.base64.encodeFile(val.file).then((base64File: string) => {
        return {
          file: val.file,
          base64File
        }
      });
    });
  }

  uploadFile(file, filename, bucketname){
    filename = (new Date()).getTime() + filename;
    filename.replace(/ /g,"_");
    return this.getToken().then((val) => {
      if(val){
        return this.http.post<Response>(this.getUrl(this.ismURL, `/uploadImage/${val.societyId}`,val), {
          file,
          filename,
          bucketname
        }).toPromise();
      }
    });
  }

  getUserDetails(){
    return this.storage.get("loginDetails");
  }

  getToken(){
    return this.storage.get("loginDetails");
  }

  getUrl(url:string, link: string, val: any):string {
    return `${url}${link}?api-token=${val.api_token}&user-id=${val.id}`;
  }

}

export class Response{
  constructor(res){
    console.log(res);
  }
  status: string;
  message: string;
  data?: any;
  metadata?: any;
  complaintTypeList?: any;
}

interface PanicData {
  message?: string;
  type?: string;
}



// WEBPACK FOOTER //
// ./src/providers/extra/extra.ts